import React, { Component, Fragment } from 'react';
import Loader from '../loaderComponents/Loader';
import ContentLoader from 'react-content-loader';

const CircularLoader = props => (
  <ContentLoader
    height="100"
    primaryColor={props.pcolor ? props.pcolor : ' #f0f0f0'}
    secondaryColor={props.sec_color ? props.sec_color : '#d6dcd6'}
  >
    <circle cx="200" cy="50" r="30" />
  </ContentLoader>
);

class Profile extends Component {
  render() {
    return (
      <Fragment>
        <ProfileDetails />
        <ProfileOperations />
      </Fragment>
    );
  }
}

class ProfileOperations extends Component {
  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 p-0">
        <div className="profile-detail-container">
          <h3 className="mt-4">Edit Personal Details</h3>
          <Loader height={20} width={330} />

          <hr className="separator" />
          <div className="profile-form-container mt-4">
            <div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <Loader height={30} width={380} />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email address</label>
                <Loader height={30} width={380} />
              </div>
              <div className="form-group">
                <label htmlFor="contact">Contact Address</label>
                <Loader height={30} width={380} />
              </div>
            </div>
          </div>
        </div>
        {/* button */}
        <div className="footer">
          {/* subtitute active class for disabled to either make button active or inactive */}
          <button className="position-relative btn w-100 btn-primary-big btn-border-radius-login active">
            <Loader width="350" height="30" pcolor="#00ba12" />
          </button>
        </div>
      </div>
    );
  }
}

class ProfileDetails extends Component {
  render() {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 p-0 border-right">
        <div className="profile-details text-center">
          <CircularLoader height={70} width={70} xOffset={true} />
          <div className="name">
            <Loader height={10} width={135} xOffset={true} />
          </div>
          <div className="matric-number">
            <Loader height={10} width={135} xOffset={true} />
          </div>
        </div>
        <div className="profile-detail-container">
          <h3>Academic Details</h3>
          <div className="row detail-container m-0">
            <div className="col-lg-6 text">Level</div>
            <div className="col-lg-6 text text-dark bold text-lg-right">
              <Loader height={30} width={150} xOffset={true} />
            </div>
          </div>
          <hr className="separator" />
          <div className="row detail-container m-0">
            <div className="col-lg-6 text">Programme</div>
            <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
              <Loader height={30} width={150} xOffset={true} />{' '}
            </div>
          </div>
          <hr className="separator" />
          <div className="row detail-container m-0">
            <div className="col-lg-6 text">Faculty</div>
            <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
              <Loader height={30} width={150} xOffset={true} />{' '}
            </div>
          </div>
          <hr className="separator" />
          <div className="row detail-container m-0">
            <div className="col-lg-6 text">Email</div>
            <div className="col-lg-6 text text-dark bold text-lg-right overflow-ellipsis">
              <Loader height={30} width={150} xOffset={true} />{' '}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
